import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

export const schemaLoanRequestResolver_GetBucketHistory = LoanRequestsTableDefinitionZod.shape.bucketHistory;

export type SchemaLoanRequestResolver_GetBucketHistory = z.infer<typeof schemaLoanRequestResolver_GetBucketHistory>;

type Arguments = {
    id: string;
    position?: number;
};

export type LoanRequestResolver_GetBucketHistory = Resolver<Arguments, SchemaLoanRequestResolver_GetBucketHistory>;
